import { getSubdomain } from "../utils/whitelabel";

export const getThemeName = () => {
  const subdomain = getSubdomain(window.location.hostname);
  const THEME_NAME = `theme-${subdomain}`;
  return THEME_NAME;
};
